import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listaMasajes } from '../../assets/data/masajes';
import { Modal, Button, Container, Row, Col, Card } from 'react-bootstrap';

const MasajesScreen = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMasaje, setSelectedMasaje] = useState(null);
  const navigate = useNavigate();

  const handleOpenModal = (masaje) => {
    setSelectedMasaje(masaje);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMasaje(null);
  };

  const handleReservar = () => {
    if (selectedMasaje) {
      navigate(`/cita?tipo=${encodeURIComponent(selectedMasaje.altTitle || selectedMasaje.title)}`);
      handleCloseModal();
    }
  };

  return (
    <Container className="py-4">
      <h1 className="text-center">Masajes</h1>
      <p className='text-center  mb-4'>Haz click para ver el detalle</p>
      <Row>
        {listaMasajes.map((masaje, idx) => (
          <Col key={idx} md={4} className="mb-4">
            <Card onClick={() => handleOpenModal(masaje)} style={{ cursor: 'pointer' }}>
              {(masaje.imgFull || masaje.img) && (
                <Card.Img
                  variant="top"
                  src={masaje.imgFull || masaje.img}
                  alt={masaje.title}
                  style={{ height: '250px', objectFit: 'cover' }}
                />
              )}
              <Card.Body>
                <Card.Title className="text-center">{masaje.title}</Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {selectedMasaje && (
        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedMasaje.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(selectedMasaje.imgFull || selectedMasaje.img) && (
              <img
                src={selectedMasaje.imgFull || selectedMasaje.img}
                alt={selectedMasaje.title}
                className="img-fluid mb-3"
                style={{ maxHeight: '400px', objectFit: 'cover', width: '100%' }}
              />
            )}
            {selectedMasaje.altTitle && <h5>{selectedMasaje.altTitle}</h5>}
            <p>{selectedMasaje.text}</p>
            {selectedMasaje.precio && <p><strong>Precio:</strong> {selectedMasaje.precio} €</p>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleReservar}>
              Reservar este masaje
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default MasajesScreen;
